// The /create studio's main flow (pages/create.tsx, components/studio:
// VoicePicker, WhoSings, SongPicker, SongSources, useCreateCover).
// See messages/README.md for how to add strings.
export const studio = {
  en: {
    // pages/create.tsx
    "studio.title.none": "Make a cover",
    "studio.title.one": "Make {name} sing",
    "studio.title.many": "Make them sing",
    "studio.section.voice": "Voice",
    "studio.section.whoSings": "Who sings",
    "studio.section.count": "{n} of {max}",
    "studio.section.audio": "Audio",
    "studio.pickVoice": "Pick a voice",
    "studio.pickVoiceNote": "Any of 60,000+ voices, or your own",
    "studio.addVoice": "Add a voice",
    "studio.whoSingsWhen": "Who sings when",
    "studio.sound": "Sound",
    "studio.video": "Video",
    "studio.video.off": "Race your voices in a Marble Run",
    "studio.video.on": "Marble Run · 1 coin",
    "studio.video.add": "Add Marble Run · 1 coin",
    "studio.coins.unlimited": "Unlimited coins on Power",
    "studio.coins.one": "{count} coin left",
    "studio.coins.other": "{count} coins left",
    "studio.done": "Done",
    "studio.remove": "Remove",
    "studio.cta.pickVoice": "Pick a voice first",
    "studio.cta.addAudio": "Add audio",
    "studio.cta.create": "Create cover",
    "studio.auth.video": "Sign up to make a video",
    "studio.auth.audio": "Sign up to use your audio",
    "studio.auth.save": "Save your cover",
    "studio.upgrade.marbleRun": "Upgrade to Creator to make Marble Run videos",
    "studio.creatorReady": "You're on Creator. Pick your Marble Run.",
    "studio.maxVoices": "You can select a maximum of {max} voices.",
    "studio.alreadyIn": "{name} is already in this cover.",

    // VoicePicker
    "studio.voices.search": "Search voices",
    "studio.voices.clear": "Clear search",
    "studio.voices.trending": "Trending",
    "studio.voices.recent": "Recently used",
    "studio.voices.mine": "My voices",
    "studio.voices.music": "Music",
    "studio.voices.cartoon": "Cartoon",
    "studio.voices.gaming": "Gaming",
    "studio.voices.anime": "Anime",
    "studio.voices.publicFigure": "Public figure",
    "studio.voices.oftenWith": "Often with {name}",
    "studio.voices.pairedWith": "Often paired with {name}",
    "studio.voices.add": "Add {name}",
    "studio.voices.change": "Change {name}",
    "studio.voices.removeName": "Remove {name}",
    "studio.voices.upTo": "Up to {max}",
    "studio.voices.makeDuet": "Make it a duet",
    "studio.voices.uses": "{n} uses",
    "studio.voices.noMatch": "No voices match that search.",
    "studio.voices.noMine": "You have no trained voices yet.",
    "studio.voices.noPairs":
      "No duets with this voice yet this week. Try Trending.",
    "studio.empty": "Nothing here yet.",
    "studio.change": "Change",

    // WhoSings
    "studio.who.auto": "Auto pick",
    "studio.who.manual": "Choose myself",
    "studio.who.chose.one": "You chose · {n} part",
    "studio.who.chose.other": "You chose · {n} parts",
    "studio.who.autoExplain":
      "The voices take turns wherever the singing changes.",
    "studio.who.autoCanChoose":
      "Want a say? Choose myself lets you pick who sings each part.",
    "studio.who.autoNeedsFile":
      "Choosing yourself needs an upload, a recording or a library song.",
    "studio.who.loading": "Loading the song…",
    "studio.who.failed":
      "We couldn't play this song here, so Jammable will decide.",
    "studio.who.pause": "Pause",
    "studio.who.playSong": "Play the song",
    "studio.who.partLabel": "{name}, {start} to {end}",
    "studio.who.moveSwap": "Move where the voices swap",
    "studio.who.part": "Part {n}",
    "studio.who.play": "Play",
    "studio.who.split": "Split",
    "studio.who.takeOver": "Who takes this part over?",
    "studio.who.before": "The part before",
    "studio.who.after": "The part after",
    "studio.who.sungBy": "Sung by",
    "studio.who.hint":
      "Tap a part to hear it and choose who sings it. Drag the white handles to move where the voices swap.",
    "studio.who.tooShort": "Each part needs at least {secs} seconds.",

    // SongPicker
    "studio.song.upload": "Upload",
    "studio.song.library": "Library",
    "studio.song.tts": "Type words",
    "studio.song.generate": "AI song",
    "studio.song.mic": "Record",
    "studio.song.sources": "Where the song comes from",
    "studio.song.rights": "Only upload audio you have the rights to use.",
    "studio.song.search": "Search songs",
    "studio.song.searchUploads": "Search your uploads",
    "studio.song.searchLibrary": "Search the song library",
    "studio.song.popular": "Popular",
    "studio.song.yourUploads": "Your uploads",
    "studio.song.noMatch": "No songs match that search.",
    "studio.song.noUploads": "You haven't uploaded anything yet.",
    "studio.song.picked": "Picked",
    "studio.source.generate": "AI Generated",
    "studio.source.upload": "Uploaded",
    "studio.source.library": "From Library",
    "studio.source.mic": "Recorded",
    "studio.source.tts": "Text to Speech",

    // SongSources: Type words
    "studio.tts.what": "What should they say?",
    "studio.tts.placeholder": "Type what they should say...",
    "studio.tts.baseVoice": "BASE VOICE",
    "studio.tts.accent": "ACCENT",
    "studio.tts.delivery": "DELIVERY",
    "studio.tts.use": "Use these words",
    "studio.tts.empty": "Please enter some text.",
    "studio.tts.tooLong": "Text exceeds the maximum limit of {max} characters.",
    "studio.tts.gender.female": "Female",
    "studio.tts.gender.male": "Male",
    "studio.tts.accent.US": "American",
    "studio.tts.accent.GB": "British",
    "studio.tts.accent.FR": "French",
    "studio.tts.accent.DE": "German",
    "studio.tts.accent.ES": "Spanish",
    "studio.tts.accent.IT": "Italian",
    "studio.tts.accent.KR": "Korean",
    "studio.tts.accent.AU": "Australian",
    "studio.tts.accent.JP": "Japanese",
    "studio.tts.expr.default": "Default",
    "studio.tts.expr.whispered": "Whispered",
    "studio.tts.expr.happy": "Happy",
    "studio.tts.expr.sad": "Sad",
    "studio.tts.expr.angry": "Angry",
    "studio.tts.expr.shouting": "Shouting",
    "studio.tts.expr.terrified": "Terrified",

    // SongSources: AI song
    "studio.ai.style": "PICK A STYLE, OR DESCRIBE ONE",
    "studio.ai.styleLabel": "Song style",
    "studio.ai.stylePlaceholder":
      "e.g. upbeat summer pop, acoustic guitar, catchy chorus",
    "studio.ai.lyrics": "Lyrics",
    // [Verse], [Chorus], [Bridge] are tags the generator reads: keep them.
    "studio.ai.lyricsPlaceholder":
      "Leave blank to let AI write the lyrics, or:\n\n[Verse 1]\nType your lyrics here...\n\n[Chorus]\nUse [Verse], [Chorus], [Bridge] tags to give it structure",
    "studio.ai.ownLyrics": "+ Write your own lyrics (otherwise AI writes them)",
    "studio.ai.use": "Use this song",
    "studio.ai.noStyle": "Describe the style of the song.",
    "studio.ai.styleTooLong":
      "Style description must be under {max} characters.",
    "studio.ai.lyricsTooLong": "Lyrics must be under {max} characters.",
    "studio.ai.genre.pop": "Pop",
    "studio.ai.genre.trap": "Trap",
    "studio.ai.genre.rnb": "R&B",
    "studio.ai.genre.indie": "Indie",
    "studio.ai.genre.kpop": "K-pop",
    "studio.ai.genre.edm": "EDM",
    "studio.ai.genre.lofi": "Lo-fi",
    "studio.ai.genre.country": "Country",
    "studio.seo.title": "Create a cover | Jammable",
    "studio.seo.description":
      "Pick a voice, add audio you have the rights to use, and make an AI cover on Jammable.",
  },
};
